import React from 'react'
import { IUser } from '../../../../api/types/user'
import { EditUser } from '../EditUser/EditUser'
import { CheckIcon } from '../../../../components/CheckIcon/CheckIcon'
import { DeleteUser } from '../DeleteUser/DeleteUser'
import { Link as RouterLink } from 'react-router-dom'
import { Link, TableCell, TableRow } from '@mui/material'
import { useAuth } from '../../../../context/Auth'

interface Props {
  user: IUser
}

export const UserRow: React.FC<Props> = ({ user }) => {
  const auth = useAuth()
  return (
    <TableRow>
      <TableCell>
        <Link component={RouterLink} to={`/users/${user?.id}`} underline="hover">
          {user?.username}
        </Link>
      </TableCell>
      <TableCell align="center">
        <CheckIcon checked={user?.admin} />
      </TableCell>
      <TableCell align="center">
        <CheckIcon checked={user?.gm} />
      </TableCell>
      <TableCell align="right">
        {auth?.admin && <EditUser user={user} />}
        {auth?.admin && <DeleteUser user={user} />}
      </TableCell>
    </TableRow>
  )
}
